import { forwardRef, useRef, useState } from 'react';
import { setRef } from '../../../util/ref-util';
import { postfixTestId } from '../../../util/testId';
import { ButtonVariant } from '../../Button';
import { BaseButton } from '../../Button/__internal__';
import { ContextMenu } from '../../ContextMenu';
import { Menu } from '../../Menu';
import cn from '../../Button/__internal__/BaseButton.css.json';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const longPressThreshold = 750;
export const ContextMenuButton = /*#__PURE__*/forwardRef((props, ref) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const buttonRef = useRef(null);
  const timerRef = useRef(-1);
  const openMenu = () => {
    if (!props.disabled) setIsMenuOpen(true);
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(ContextMenu, {
      onContextMenu: openMenu,
      children: /*#__PURE__*/_jsx(BaseButton, {
        ref: button => {
          setRef(buttonRef, button);
          setRef(ref, button);
        },
        disabled: props.disabled,
        testId: props.testId,
        variant: ButtonVariant.Icon,
        className: isMenuOpen ? cn.active : undefined,
        onPress: () => {
          clearTimeout(timerRef.current);
          if (!isMenuOpen) props.onPress?.();
        },
        onMouseDown: e => {
          // left button
          if (e.button === 0) {
            timerRef.current = window.setTimeout(openMenu, longPressThreshold);
          }
        },
        onMouseLeave: () => {
          clearTimeout(timerRef.current);
        },
        tooltip: props.tooltip,
        ariaLabel: props.tooltip,
        focusable: props.focusable ?? true,
        icon: props.icon
      })
    }), /*#__PURE__*/_jsx(Menu, {
      testId: postfixTestId(props.testId, 'menu'),
      position: {
        dockingElement: buttonRef.current,
        verticalAlign: 'end',
        horizontalAlign: 'end'
      },
      isOpen: isMenuOpen,
      sections: props.sections,
      onItemSelected: location => {
        setIsMenuOpen(false);
        buttonRef.current?.focus();
        props.onItemSelected(location);
      },
      onDismiss: restoreFocus => {
        setIsMenuOpen(false);
        if (restoreFocus) buttonRef.current?.focus();
      }
    })]
  });
});
//# sourceMappingURL=ContextMenuButton.js.map